
import {
  Datagrid,
  List,
  ReferenceField,
  TextField,
  Filter,
  ReferenceInput,
  SelectField,
  SelectInput,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import { LocalizedDateField } from "../../components/localized-date-field.component";

const LogsFilter = (props: any) => (
  <Filter {...props}>
    <ReferenceInput
      label="Buscar por usuário"
      reference="users"
      source="userId"
      sort={{ field: "name", order: "ASC" }}
      filterToQuery={(searchText: string) => ({ name: searchText })}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const LogsList = (props: any) => {
  return (
    <List {...props} filters={<LogsFilter />}>
      <Datagrid rowClick="edit">
        <ReferenceField label="Usuário" reference="users" source="userId">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="level" label="Level" />
        <TextField source="message" label="Mensagem" />
        <JsonField
          source="stack"
          label="Stack"
          jsonString={false}
          reactJsonOptions={{
            // Props passed to react-json-view
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
        />
        <SelectField
          source="status"
          label="Status"
          choices={[
            { id: 0, name: "Aberto" },
            { id: 1, name: "Resolvido" },
          ]}
        />
        <LocalizedDateField label="Criado em" source="timestamp" showTime={true} />
      </Datagrid>
    </List>
  );
};
